import DeliveryPointPage from 'Pages/static/DeliveryPointPage';
import { SALESFORCE_CONTACT_URL, SALESFORCE_FAQ_URL } from 'PotagerLogic/Constants/Salesforce';
import ExternalRedirect from 'Pages/ExternalRedirect.vue';

export default [
  {
    name: 'devenir-point-de-retrait',
    path: '/devenir-point-de-retrait-partenaire/',
    meta: {
      scrollToTop: true,
    },
    component: DeliveryPointPage,
  },

  {
    name: 'external',
    path: '/external',
    component: ExternalRedirect,
  },

  // for once use -> use external route (giving the URL in props)
  // for multiple use -> use specific route like /contact or /faq
  {
    name: 'contact',
    path: '/contact',
    component: ExternalRedirect,
    props: {
      url: SALESFORCE_CONTACT_URL,
    }
  },

  {
    name: 'faq',
    path: '/faq',
    component: ExternalRedirect,
    props: {
      url: SALESFORCE_FAQ_URL,
    }
  }
];
